import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, ShieldCheck, ChevronDown } from 'lucide-react';
import { Button, Section } from './Shared';
import { PRICE_USD, openCheckout } from '../lib/checkout';
const offerIncludes = ['Investigación central Nos Mienten.', '6 tomos principales.', '3 investigaciones especiales.', 'Acceso digital inmediato.', 'Formato digital.', 'Compatible con celular, tablet y PC.', 'Pago único.', 'Sin suscripción.'];
export function Offer() {
  return <Section id="oferta" darker className="relative" data-id="element-52" data-mp="ytxy8zuma6yw">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-brand-gold/5 via-brand-dark to-brand-dark -z-10" data-id="element-53" data-mp="u266wn3mzx7p" />

      <div className="text-center max-w-2xl mx-auto mb-7 md:mb-10" data-id="element-54" data-mp="p1ij0aapfwhp">
        <h2 className="font-serif text-2xl md:text-4xl font-bold text-white mb-3" data-id="element-55" data-mp="1mjscnlul43l9">
          Entra hoy al archivo completo.
        </h2>
        <p className="text-sm md:text-lg text-brand-muted" data-id="element-56" data-mp="1hqh157etuyn0">
          Recibe la colección digital Nos Mienten con 6 tomos principales y 3
          investigaciones especiales incluidas.
        </p>
      </div>

      <div className="max-w-md mx-auto bg-brand-anthracite rounded-2xl border border-brand-gold/40 shadow-[0_0_50px_rgba(197,160,89,0.15)] overflow-hidden" data-id="element-57" data-mp="27h4yn348krgi">
        <div className="border-b border-brand-gold/20 px-6 py-4 text-center" data-id="element-58" data-mp="2cen94xxwjeqm">
          <p className="text-[10px] font-medium tracking-[0.22em] text-brand-gold uppercase mb-1" data-id="element-59" data-mp="1xhw7sj4o3syd">
            Precio especial de relanzamiento
          </p>
          <h3 className="font-serif text-lg md:text-xl text-white" data-id="element-60" data-mp="1oi94frsdod2o">
            Nos Mienten — Archivo Digital Completo
          </h3>
        </div>

        <div className="p-6 md:p-8" data-id="element-61" data-mp="1tidplv48dvz8">
          <ul className="space-y-2.5 mb-7" data-id="element-62" data-mp="1tjgfq0tqbue3">
            {offerIncludes.map(item => <li key={item} className="flex items-start gap-2.5 text-[13px] md:text-sm text-brand-offWhite leading-snug" data-id="element-63" data-mp="3ix21lv8wtbwq">
                <Check className="w-4 h-4 text-brand-gold shrink-0 mt-0.5" data-id="element-64" data-mp="3lhhtzm2x71gv" />
                <span data-id="element-65" data-mp="3helfa6gi3pi7">{item}</span>
              </li>)}
          </ul>

          <div className="text-center mb-6" data-id="element-66" data-mp="3cfs26f54m0ik">
            <div className="font-serif text-5xl md:text-6xl font-bold text-brand-gold mb-2" data-id="element-67" data-mp="3cgtiay101d75">
              {PRICE_USD}
            </div>
            <p className="text-[11px] md:text-xs text-brand-muted leading-relaxed" data-id="element-68" data-mp="37ja23skqqqck">
              Pago único. El checkout puede mostrar el monto en tu moneda local
              según disponibilidad.
            </p>
          </div>

          <Button fullWidth className="text-base py-5" onClick={openCheckout} data-id="element-69" data-mp="3ve4da6fllkgs">
            OBTENER ACCESO AL ARCHIVO
          </Button>

          <p className="text-center text-brand-muted text-xs mt-3" data-id="element-70" data-mp="3qf9tp29t3rvm">
            Acceso inmediato después de la compra.
          </p>
        </div>
      </div>
    </Section>;
}
export function Guarantee() {
  return <Section data-id="element-71" data-mp="mwzu5v3k57a7">
      <div className="max-w-2xl mx-auto text-center border border-brand-card rounded-2xl p-6 md:p-8 bg-brand-dark" data-id="element-72" data-mp="ua8tmggieh9l">
        <ShieldCheck className="w-9 h-9 text-brand-gold mx-auto mb-4" data-id="element-73" data-mp="z8sfkgv3rt1y" />
        <h2 className="font-serif text-xl md:text-2xl font-bold text-white mb-3" data-id="element-74" data-mp="zb563iexfbqm">
          Compra con tranquilidad.
        </h2>
        <p className="text-sm md:text-base text-brand-muted leading-relaxed" data-id="element-75" data-mp="19817l46eqxlo">
          Si el archivo no es lo que esperabas, escríbenos dentro de los
          primeros 7 días y te ayudamos con la devolución según las condiciones
          de garantía.
        </p>
      </div>
    </Section>;
}
const faqs = [{
  q: '¿Qué recibo exactamente al comprar?',
  a: 'Recibes acceso digital a la colección Nos Mienten, incluyendo la investigación central, 6 tomos principales y 3 investigaciones especiales.'
}, {
  q: '¿Es un libro físico o digital?',
  a: 'Es un producto digital. Puedes leerlo desde tu celular, tablet o computadora.'
}, {
  q: '¿Cuándo recibo el acceso?',
  a: 'El acceso se entrega de forma inmediata después de completar la compra.'
}, {
  q: '¿Es una suscripción?',
  a: 'No. Es un pago único.'
}, {
  q: '¿El precio es en dólares?',
  a: 'El precio base es USD 9,99. El checkout puede mostrar el monto en tu moneda local según disponibilidad.'
}, {
  q: '¿Necesito saber del tema para entenderlo?',
  a: 'No. El archivo está pensado para cualquier persona curiosa que quiera explorar casos, documentos, testimonios e hipótesis.'
}, {
  q: '¿Esto intenta convencerme de una teoría?',
  a: 'No. La colección está planteada como un recorrido documental y narrativo. No busca imponer una creencia, sino presentar material para que saques tus propias conclusiones.'
}, {
  q: '¿Qué hago si no recibo el acceso?',
  a: 'Puedes contactar al soporte con el email usado en la compra para recibir ayuda.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);
  return <Section darker data-id="element-76" data-mp="7hb7cutugfza">
      <div className="max-w-3xl mx-auto" data-id="element-77" data-mp="7g054zg1rgaa">
        <h2 className="font-serif text-2xl md:text-4xl font-bold text-white text-center mb-7 md:mb-10" data-id="element-78" data-mp="7j5wklc5eu96">
          Preguntas frecuentes
        </h2>
        <div className="space-y-2.5" data-id="element-79" data-mp="3tp2sb76xyz66">
          {faqs.map((faq, idx) => <div key={faq.q} className="bg-brand-anthracite border border-brand-card rounded-lg overflow-hidden" data-id="element-80" data-mp="2hq9knqeudo5" data-mpi={idx}>
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} aria-expanded={openIdx === idx} className="w-full px-5 py-4 flex items-center justify-between gap-4 text-left focus:outline-none focus-visible:ring-1 focus-visible:ring-brand-gold" data-id="element-81" data-mp="q82mye4fd2m4">
                <span className="font-medium text-white text-sm md:text-base" data-id="element-82" data-mp="lehq4pekieoi">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-gold shrink-0 transition-transform duration-200 ${openIdx === idx ? 'rotate-180' : ''}`} data-id="element-83" data-mp="1dxnalabiwo1q" />
              </button>
              <AnimatePresence initial={false} data-id="element-84" data-mp="1itrbvpu0jypq">
                {openIdx === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-85" data-mp="1dueq78evoxoq">
                    <p className="px-5 pb-4 text-brand-muted text-sm border-t border-brand-card/60 pt-3.5 leading-relaxed" data-id="element-86" data-mp="m4a0cu8cnig4">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Section>;
}
export function FinalCTA() {
  return <Section data-id="element-87" data-mp="2xsy8hh89r5yx">
      <div className="max-w-2xl mx-auto text-center" data-id="element-88" data-mp="31sypn9mr5v9o">
        <h2 className="font-serif text-2xl md:text-4xl font-bold text-white mb-4" data-id="element-89" data-mp="31ti76p8hqhn6">
          El archivo está abierto.
        </h2>
        <p className="text-sm md:text-lg text-brand-muted mb-8" data-id="element-90" data-mp="2a1j5rnckymn5">
          No para decirte qué creer. Para que puedas mirar por tu cuenta lo que
          casi nunca aparece reunido en un mismo lugar.
        </p>
        <Button className="text-base py-5 px-8 w-full sm:w-auto" onClick={openCheckout} data-id="element-91" data-mp="2j2h9s5n0qu5q">
          ENTRAR A NOS MIENTEN POR {PRICE_USD}
        </Button>
        <p className="text-xs text-brand-muted mt-4" data-id="element-92" data-mp="1qdjso5ujn3ek">
          Pago único · Acceso inmediato · Lectura en cualquier dispositivo
        </p>
      </div>
    </Section>;
}